import * as styles from "./TypeAutocomplete.css";

export type TypeAutocompleteOption = {
  alias: string;
  value: string;
  label: string;
};

export type TypeAutocompleteProps = {
  options: TypeAutocompleteOption[];
  highlightedIndex: number;
  onHighlight: (index: number) => void;
  onSelect: (value: string) => void;
};

export function TypeAutocomplete({
  options,
  highlightedIndex,
  onHighlight,
  onSelect,
}: TypeAutocompleteProps) {
  if (0 === options.length) {
    return null;
  }

  return (
    <div className={styles.list} role="listbox">
      {options.map((option, index) => (
        <div
          key={option.value}
          role="option"
          aria-selected={index === highlightedIndex}
          data-highlighted={index === highlightedIndex ? "" : undefined}
          className={styles.option}
          onMouseDown={(event) => event.preventDefault()}
          onMouseEnter={() => onHighlight(index)}
          onClick={() => onSelect(option.value)}
        >
          <span className={styles.alias}>{option.alias}</span>
          <span className={styles.label}>{option.label}</span>
        </div>
      ))}
    </div>
  );
}
